















import Vue from "vue"
import { vueWith } from "./../vueWith"

/**
 * @example
 *  <week-component
 *    v-model="week"
 *    class="select"
 *    v-bind:class="{ none: radio == 1 || frequency != 1 }"
 *  ></week-component>
 */
export default vueWith<{
  // $refs: { table: TableComponentMethods },
}>().extend({
  components: {
    // TableComponent,
  },
  props: {
    value: String,
  },
  data() {
    return {
      // value: "-1",
    }
  },

  computed: {
  },

  /** Vue構築完了時の処理 */
  created: function init() {
    //
  },

  methods: {

    updateValue(e: any) {
      this.$emit("input", e.target!.value)
    },

    // 子から呼ばれる ---------------------------------------------

  },
})


